export default __webpack_public_path__ + "1a3604a1dfa3cb2058f21c037d4f08aa.png";